import { useEffect, useState } from "react";
import { PhoneMockup } from "./PhoneMockup";

export function Hero() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Small delay so the initial hidden state paints first
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-16">
      {/* Gradient blobs */}
      <div className="absolute top-1/4 -left-32 w-[500px] h-[500px] bg-brand-teal/20 rounded-full blur-[120px] animate-pulse-glow" />
      <div className="absolute bottom-1/4 -right-32 w-[500px] h-[500px] bg-brand-indigo/20 rounded-full blur-[120px] animate-pulse-glow" style={{ animationDelay: "1.5s" }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 lg:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: copy */}
          <div className={`flex-1 text-center lg:text-left hero-enter ${mounted ? "visible" : ""}`}>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight text-white">
              Know your dough.
              <br />
              <span className="text-brand-teal">Your future</span> is rising.
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-text-secondary max-w-lg mx-auto lg:mx-0">
              Budget smarter, learn finance through bite-sized lessons, simulate your future, and compete with friends. All in one app.
            </p>

            {/* Store badges */}
            <div className="mt-8 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <a href="https://apps.apple.com/us/app/dough-financial-wellness/id6757439224" className="transition-transform hover:scale-105">
                <img src="/images/appstore-badge.svg" alt="Download on the App Store" className="h-[52px]" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.betteryou.BetterFinance&hl=en_US" className="transition-transform hover:scale-105">
                <img src="/images/googleplay-badge.svg" alt="Get it on Google Play" className="h-[52px]" />
              </a>
            </div>
          </div>

          {/* Right: phone mockup */}
          <div
            className={`flex-shrink-0 hero-enter ${mounted ? "visible" : ""}`}
            style={{ transitionDelay: "200ms" }}
          >
            <div className="animate-float">
              <PhoneMockup
                src="/images/screenshots/dashboard.png"
                alt="Dough dashboard"
                width={280}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
